import { render, staticRenderFns } from "./SuivieDepense.vue?vue&type=template&id=2ca6980a&scoped=true&"
import script from "./SuivieDepense.js?vue&type=script&lang=js&"
export * from "./SuivieDepense.js?vue&type=script&lang=js&"
import style0 from "./SuivieDepense.vue?vue&type=style&index=0&id=2ca6980a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6980a",
  null
  
)

export default component.exports